module.exports = __webpack_public_path__ + "media/images/searches/form-success-bus-e580fcc94d42db3b47e1c45de971d128.png";